<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">{{ $t($route.name) }}</h2>
        <div class="header-actions">

          <!-- Qidiruv -->
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input
              id="filter-input"
              v-model="filter"
              type="search"
              :placeholder="$t('Qidiruv...')"
              class="modern-search"
            >
          </div>

          <!-- Fayl yuklash -->
          <button
            v-if="rule.open==true"
            class="tool-btn"
            v-b-modal.modal-upload
            type="button"
          >
            <b-icon icon="file-earmark-arrow-up"></b-icon> {{ $t("Файл") }}
          </button>

          <!-- Oddiy Excel (Наименование, Баркод, Количество...) -->
          <button
            v-if="rule.open==true"
            class="tool-btn"
            v-b-modal.modal-upload-flex
            type="button"
            title="Products.xlsx formatida yuklash"
          >
            <b-icon icon="file-earmark-spreadsheet"></b-icon> Excel+
          </button>

          <!-- Excel REVIZYA — qoldiqqa qo'shish (qarz va kassaga ta'sirsiz) -->
          <button
            v-if="rule.open==true"
            class="tool-btn"
            v-b-modal.modal-upload-revision
            type="button"
            title="Excel'dan revizya bilan qoldiq qo'shish (qarzsiz)"
          >
            <b-icon icon="boxes"></b-icon> Excel→Revizya
          </button>

          <!-- Qo'shish -->
          <button
            v-if="rule.open==true"
            class="add-btn"
            @click="Href('/kirim/create')"
          >
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }}<sup>ins</sup>
          </button>

          <!-- Yangilash -->
          <button class="refresh-btn" @click="Data()" title="Yangilash">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>

          <top></top>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 90px">{{ $t('ФАКТ №') }}</th>
                <th style="width: 140px">{{ $t('ВАҚТ') }}</th>
                <th>{{ $t('ЕТКАЗУВЧИ') }}</th>
                <th>{{ $t('СКЛАД') }}</th>
                <th style="width: 90px; text-align: right;">{{ $t('СОНИ') }}</th>
                <th style="width: 120px; text-align: right;">{{ $t('СУММА') }}</th>
                <th style="width: 130px; text-align: right;">{{ $t('КИРИМ') }} сумма</th>
                <th style="width: 120px;">{{ $t('ТЎЛОВ ТУРИ') }}</th>
                <th style="width: 130px;">{{ $t('ФОЙДАЛАНУВЧИ') }}</th>
                <th style="width: 110px; text-align: center;">{{ $t('АМАЛЛАР') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, idx) in filteredRows"
                :key="item.id"
                @dblclick="Update(item, idx)"
              >
                <td>
                  <span class="id-badge">{{ item.number }}</span>
                </td>
                <td>{{ Date(item.created_at) }}</td>
                <td class="font-bold">
                  <span v-if="item.kontragent != null">{{ item.kontragent.name }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <span v-if="item.sklad != null">{{ item.sklad.name }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td style="text-align: right;">{{ item.count_all | numFormat }}</td>
                <td style="text-align: right;">{{ item.summa | numFormat }}</td>
                <td style="text-align: right;">{{ item.prixod_summa | numFormat }}</td>
                <td>
                  <span v-if="item.pay_type != null">{{ item.pay_type.name }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <span v-if="item.user != null">{{ item.user.first_name }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <div class="actions" v-if="rule.change==true">
                    <button class="icon-btn barcode" title="Shtrix chiqarish"
                      @click="openBarcodeForPrixod(item.id)">
                      <b-icon icon="upc"></b-icon>
                    </button>
                    <button class="icon-btn edit" @click="$router.push('/kirim/update/' + item.id)">
                      <b-icon icon="pencil-square"></b-icon>
                    </button>
                    <button class="icon-btn del" @click="Trash(item.id)">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Bo'sh holat -->
              <tr v-if="filteredRows.length === 0">
                <td colspan="10" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- ═══════════════ 🏷 PRIXOD BARCODE MODAL ═══════════════ -->
        <div v-if="bcModal.show" class="bc-overlay" @click.self="bcModal.show = false">
          <div class="bc-modal">
            <div class="bc-head">
              <h3 class="bc-title">
                🏷 Prixod #{{ bcModal.prixodNumber }} shtrixlari
                <span class="bc-sub">({{ bcModal.list.length }} ta mahsulot)</span>
              </h3>
              <button class="bc-close" @click="bcModal.show = false">&times;</button>
            </div>

            <div class="bc-body">
              <div v-if="bcModal.loading" class="bc-empty">Yuklanmoqda...</div>
              <template v-else>
                <div class="bc-options">
                  <div class="bc-opt">
                    <label class="bc-label">Narx turi</label>
                    <select v-model="bcModal.priceType" class="bc-select">
                      <option value="chakana">Chakana</option>
                      <option value="optom">Optom</option>
                    </select>
                  </div>
                  <div class="bc-opt">
                    <label class="bc-toggle">
                      <input type="checkbox" v-model="bcModal.showPrice"> Narxni chop etish
                    </label>
                  </div>

                  <!-- 🎯 Ommaviy son o'rnatish -->
                  <div class="bc-opt bc-bulk">
                    <label class="bc-label">Hammaga son</label>
                    <div class="bc-bulk-row">
                      <input v-model.number="bcModal.bulkCount" type="number" min="0"
                        class="bc-qty" placeholder="5" @keyup.enter="applyBulkCount()" />
                      <button class="bc-btn-apply" @click="applyBulkCount()" :title="bcSelectedCount > 0 ? `${bcSelectedCount} ta tanlanganga` : 'Hammasiga'">
                        Qo'llash
                      </button>
                    </div>
                  </div>

                  <div class="bc-opt" style="margin-left:auto">
                    <button class="bc-btn-clear" @click="bcModal.list.forEach(it => it.count = 0)">
                      <b-icon icon="x-circle"></b-icon> Sonlarni 0
                    </button>
                  </div>
                </div>

                <div v-if="bcModal.list.length === 0" class="bc-empty">
                  Bu prixodda mahsulot yo'q.
                </div>
                <table v-else class="bc-table">
                  <thead>
                    <tr>
                      <th style="width:36px; text-align:center">
                        <input type="checkbox"
                          :checked="bcAllSelected"
                          :indeterminate.prop="bcSomeSelected && !bcAllSelected"
                          @change="toggleSelectAll($event)"
                          title="Hammasini tanlash" />
                      </th>
                      <th style="width:40px">№</th>
                      <th>Mahsulot</th>
                      <th style="width:150px">Shtrix</th>
                      <th style="width:120px">Narx</th>
                      <th style="width:100px">Soni</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(it, i) in bcModal.list" :key="i"
                      :class="{ 'bc-no-code': !it.shtrix_kod, 'bc-row-selected': it.selected }">
                      <td style="text-align:center">
                        <input type="checkbox" v-model="it.selected" :disabled="!it.shtrix_kod" />
                      </td>
                      <td>{{ i + 1 }}</td>
                      <td>
                        <div class="bc-pname">{{ it.name }}</div>
                        <div v-if="!it.shtrix_kod" class="bc-warn">⚠️ Shtrix yo'q</div>
                      </td>
                      <td class="bc-mono">{{ it.shtrix_kod || '—' }}</td>
                      <td>{{ Number(bcModal.priceType === 'chakana' ? it.chakana_price : it.optom_price).toLocaleString('ru-RU') }}</td>
                      <td>
                        <input v-model.number="it.count" type="number" min="0" class="bc-qty" />
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5" style="text-align:right; font-weight:800">
                        Tanlangan: <b style="color:#5850ec">{{ bcSelectedCount }}</b> ta · JAMI stikerlar:
                      </td>
                      <td style="font-weight:900; color:#5850ec">
                        {{ bcTotalStickers }} ta
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </template>
            </div>

            <div class="bc-foot">
              <button class="bc-btn-cancel" @click="bcModal.show = false">Bekor</button>
              <button class="bc-btn-print"
                :disabled="!bcModal.list.some(it => it.selected && it.shtrix_kod && it.count > 0)"
                @click="printPrixodBarcodes()">
                <b-icon icon="printer-fill"></b-icon> Chop etish ({{ bcTotalStickers }} ta)
              </button>
            </div>
          </div>
        </div>

        <!-- ═══════════════ YASHIRIN PRINT MARKUP ═══════════════ -->
        <div class="bc-mybody" style="display:none">
          <span v-for="(it, i) in bcModal.list" :key="'p'+i">
            <template v-if="it.selected && it.shtrix_kod && it.count > 0">
              <div v-for="n in Number(it.count)" :key="'p'+i+'-'+n" class="bc-page">
                <div class="bc-name">{{ it.name }}</div>
                <div v-if="bcModal.showPrice" class="bc-price">
                  {{ Number(bcModal.priceType === 'chakana' ? it.chakana_price : it.optom_price).toLocaleString('ru-RU') }} so'm
                </div>
                <div class="bc-barcode-wrap">
                  <barcode :value="it.shtrix_kod" width="3.5" height="110" font-size="22" displayValue></barcode>
                </div>
              </div>
            </template>
          </span>
        </div>

        <!-- FOOTER -->
        <div class="table-footer">
          <div class="info">
            Jami: <b>{{ totalRows }}</b> ta yozuv
          </div>
          <div v-if="totalRows > $store.state.countindex">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="$store.state.countindex"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- UPLOAD MODAL -->
    <b-modal id="modal-upload" title="" size="xl" hide-footer @shown="Shovedform" modal-class="z-top-modal">
      <form>
        <div class="row">
        <div class="col-md-6">
          <label for="">Склад</label>
        </div>
        <div class="col-md-6">
          <v-select :clearable="false" class="md-input" :options="skladlist" v-model="datas.sklad_id"
          :reduce="name => name.id" label="name">
          <template #search="{attributes, events}">
            <input class="vs__search" v-bind="attributes" v-on="events" />
            <button type="button" class="modallist" v-b-modal.modal-skladlist>
              <b-icon icon="three-dots"></b-icon>
            </button>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
              <button type="button" @click="unit.name = search" v-b-modal.modal-unit class="pluss">
                +
              </button>
              <b>insert</b>
            </template>
            <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
        </div>
        <div class="col-md-6">
          <label for="">{{$t('Етказувчи')}}</label>
        </div>
        <div class="col-md-6">
          <v-select :clearable="false" class="form-control-sm required md-input" :options="kontragentlist"
          v-model="datas.kontragent_id" :reduce="name => name.id" label="name">
        </v-select>
        </div>
        <div class="col-md-6">
          <label for="">{{$t('Тўлов тури')}}</label>
        </div>
        <div class="col-md-6">
          <v-select :clearable="false" class="form-control-sm required md-input" :options="paytypelist"
          v-model="datas.pay_type_id" :reduce="name => name.id" label="name">
        </v-select>
        </div>
        <div class="col-md-6">
          <label for="">Курс</label>
        </div>
        <div class="col-md-6">
          <input type="number" v-model="datas.dollar_rate" class="form-control">
        </div>
      </div>
        <div class="col-md-12 mt-2 mb-2">
          <b-form-checkbox v-model="datas.financial_enabled" switch>
            Moliyaviy hisoblash (o'chirilsa kontragent qarzi va kassa o'zgarmaydi)
          </b-form-checkbox>
        </div>
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
        <button type="button" class="btn btn-primary" @click="Yuklash()">
          {{ $t("Сақлаш") }}
        </button>
      </form>
    </b-modal>

    <!-- Oddiy Excel yuklash (Наименование, Баркод, Количество, Цена поставки, Цена продажи, Бренд, Единица измерения) -->
    <b-modal id="modal-upload-flex" title="Excel mahsulot yuklash (qoldiqlar bilan)" size="lg" hide-footer modal-class="z-top-modal">
      <div class="alert alert-info small mb-3">
        <b>Kerakli ustunlar:</b>
        Наименование, Баркод, Количество, Цена поставки, Цена продажи, Бренд, Единица измерения.<br>
        Nomlar takrorlansa miqdorlar qo'shiladi, mavjud mahsulot bo'lsa yangilanadi.
      </div>
      <form>
        <div class="row g-2 mb-2">
          <div class="col-md-6">
            <label>Склад</label>
            <v-select :clearable="false" :options="skladlist" v-model="flex.sklad_id" :reduce="n=>n.id" label="name"></v-select>
          </div>
          <div class="col-md-6">
            <label>{{$t('Етказувчи')}}</label>
            <v-select :clearable="false" :options="kontragentlist" v-model="flex.kontragent_id" :reduce="n=>n.id" label="name"></v-select>
          </div>
          <div class="col-md-6">
            <label>{{$t('Тўлов тури')}}</label>
            <v-select :clearable="false" :options="paytypelist" v-model="flex.pay_type_id" :reduce="n=>n.id" label="name"></v-select>
          </div>
          <div class="col-md-6">
            <label>Курс</label>
            <input type="number" v-model="flex.dollar_rate" class="form-control">
          </div>
        </div>
        <div class="mb-2">
          <b-form-checkbox v-model="flex.financial_enabled" switch>
            Moliyaviy hisoblash (o'chirilsa kontragent qarzi va kassa o'zgarmaydi)
          </b-form-checkbox>
        </div>
        <input type="file" accept=".xlsx,.xls" ref="fileFlex" @change="onFlexFileChange" class="form-control mb-2">
        <button type="button" class="btn btn-success" :disabled="flexLoading || !flex.file" @click="uploadFlex">
          <span v-if="flexLoading"><span class="spinner-border spinner-border-sm"></span> Yuklanmoqda...</span>
          <span v-else>Yuklash</span>
        </button>
        <div v-if="flexResult" class="mt-3 alert alert-success small">
          <div>Jami qator: {{ flexResult.total_rows }}</div>
          <div>Unikal mahsulot: {{ flexResult.unique_products }}</div>
          <div>Yangi: {{ flexResult.created }} | Yangilangan: {{ flexResult.updated }}</div>
          <div>Jami miqdor: {{ flexResult.total_count }}</div>
          <div>Jami summa: {{ Number(flexResult.total_summa).toLocaleString() }}</div>
          <div>Prixod №: {{ flexResult.prixod_number }}</div>
        </div>
      </form>
    </b-modal>

    <!-- Excel REVIZYA orqali yuklash — kontragent qarz va kassaga ta'sirsiz -->
    <b-modal id="modal-upload-revision" title="Excel'dan REVIZYA bilan ombor qoldig'iga qo'shish" size="lg" hide-footer modal-class="z-top-modal">
      <div class="alert alert-warning small mb-3">
        <b>Bu rejimda:</b>
        <ul class="mb-0 mt-1 ps-3">
          <li>✅ Mahsulotlar ombor qoldig'iga qo'shiladi</li>
          <li>✅ Yangi mahsulotlar katalogga avto-yaratiladi</li>
          <li>❌ Ta'minotchi qarzi <b>YOZILMAYDI</b></li>
          <li>❌ Kassaga ta'sir <b>YO'Q</b></li>
          <li>📋 Hujjat turi: <b>Reviziya</b> (real=true, darhol yakunlanadi)</li>
        </ul>
      </div>
      <div class="alert alert-info small mb-3">
        <b>Kerakli ustunlar:</b>
        Наименование, Баркод, Количество, Цена поставки, Цена продажи, Бренд, Единица измерения.<br>
        Nomlar takrorlansa miqdorlar qo'shiladi.
      </div>
      <form>
        <div class="row g-2 mb-2">
          <div class="col-md-6">
            <label>Склад</label>
            <v-select :clearable="false" :options="skladlist" v-model="revUpload.sklad_id" :reduce="n=>n.id" label="name"></v-select>
          </div>
          <div class="col-md-6">
            <label>Izoh (ixtiyoriy)</label>
            <input type="text" v-model="revUpload.comment" class="form-control" placeholder="Excel'dan revizya...">
          </div>
        </div>
        <input type="file" accept=".xlsx,.xls" ref="fileRev" @change="onRevFileChange" class="form-control mb-2">
        <button type="button" class="btn btn-primary" :disabled="revLoading || !revUpload.file" @click="uploadRevision">
          <span v-if="revLoading"><span class="spinner-border spinner-border-sm"></span> Yuklanmoqda...</span>
          <span v-else><b-icon icon="boxes"></b-icon> Revizya orqali qo'shish</span>
        </button>
        <div v-if="revResult" class="mt-3 alert alert-success small">
          <div>📋 Revizya №: <b>{{ revResult.revision_id }}</b></div>
          <div>Jami qator: {{ revResult.total_rows }}</div>
          <div>Unikal mahsulot: {{ revResult.unique_products }}</div>
          <div>Yangi: {{ revResult.created }} | Yangilangan: {{ revResult.updated }}</div>
          <div>Omborga qo'shildi: <b>{{ revResult.total_count }}</b> dona</div>
          <div>Tannarx jami: {{ Number(revResult.total_summa).toLocaleString() }} so'm</div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import Top from "../Layout/Top.vue";
import { print } from "../../components/mixins/print.js";
import filterFunction from "../../utils/filterFunction";
import $ from "jquery";
import VueBarcode from 'vue-barcode';
export default {
  mixins: [print],
  components: { Top, barcode: VueBarcode },
  data() {
    return {
      datas: {
          file: "",
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          pay_type_id:1,
          dollar_rate:1,
          kontragent_id:0,
          financial_enabled: true,
        },
        flex: {
          file: null,
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          pay_type_id: 1,
          dollar_rate: 1,
          kontragent_id: null,
          financial_enabled: true,
        },
        flexLoading: false,
        flexResult: null,
        // Excel REVIZYA — qarz va kassasiz
        revUpload: {
          file: null,
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          comment: '',
        },
        revLoading: false,
        revResult: null,
        paytypelist:[],
        skladlist: [],
        kontragentlist: [],
      items: [],
      errors: "",
      fields: [
        {
          key: "number",
          label: "Факт №",
          sortable: true,
          class: "text-center column1"
        },
        {
          key: "created_at",
          label: this.$t("Вақт"),
          sortable: true,
          formatter: (value, key, item) => {
            return this.Date(value);
          },
          sortByFormatted: true,
          filterByFormatted: true,
          class: "text-center column3"
        },
        {
          key: "kontragent",
          label: this.$t("Етказувчи"),
          sortable: true,
          class: "text-center"
        },
        { key: "sklad", label: "Cклад", sortable: true, class: "text-center" },
        {
          key: "count_all",
          label: this.$t("Сони"),
          sortable: true,
          class: "text-center column2"
        },
        {
          key: "summa",
          label: "Сумма",
          sortable: true,
          class: "text-center column2"
        },
        {
          key: "prixod_summa",
          label: this.$t("Кирим")+' cумма',
          sortable: true,
          class: "text-center column2"
        },
        {
          key: "pay_type",
          label: this.$t("Тўлов тури"),
          sortable: true,
          class: "text-center column2"
        },
        {
          key: "user_id",
          label: this.$t("Фойдаланувчи"),
          sortable: true,
          class: "text-center column2",
          formatter: (value, key, item) => {
            if(item.user!=null){
              return item.user.first_name;
            }else{
              return "";
            }
          },
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: "actions", label: "", class: "column2 text-center" }
      ],
      file: "",
      totalRows: 1,
      send:false,
      currentPage: 1,
      perPage: 15,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      },

      // 🏷 Prixod barcode modali
      bcModal: {
        show: false,
        loading: false,
        prixodId: null,
        prixodNumber: '',
        priceType: 'chakana',
        showPrice: true,
        bulkCount: 1,
        list: [],   // [{ name, shtrix_kod, chakana_price, optom_price, count, selected }]
      },
    };
  },
  computed: {
    // 🏷 Barcode modal helpers
    bcSelectableItems() {
      return (this.bcModal.list || []).filter(it => it.shtrix_kod);
    },
    bcSelectedCount() {
      return (this.bcModal.list || []).filter(it => it.selected).length;
    },
    bcAllSelected() {
      const items = this.bcSelectableItems;
      return items.length > 0 && items.every(it => it.selected);
    },
    bcSomeSelected() {
      return this.bcSelectedCount > 0;
    },
    bcTotalStickers() {
      return (this.bcModal.list || [])
        .filter(it => it.selected && it.shtrix_kod)
        .reduce((s, it) => s + Number(it.count || 0), 0);
    },

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    filteredRows() {
      let rows = this.items;
      if (this.filter && this.filter.length > 1) {
        const q = this.filter.toLowerCase();
        rows = rows.filter(row =>
          (row.number && String(row.number).toLowerCase().includes(q)) ||
          (row.kontragent && row.kontragent.name && row.kontragent.name.toLowerCase().includes(q)) ||
          (row.sklad && row.sklad.name && row.sklad.name.toLowerCase().includes(q))
        );
      }
      this.totalRows = rows.length;
      const perPage = this.$store.state.countindex;
      const start = (this.currentPage - 1) * perPage;
      return rows.slice(start, start + perPage);
    }
  },
  mounted() {
    this.Data();
    this.$store.state.selected_index = null;
    // this.Interval();
  },
  created:function(){
    this.$root.$refs.index = this;
   let self=this;
      axios.get("api/v1/pay-type").then(function(response) {
        self.paytypelist = response.data;
      });
      axios.get("api/v1/sklads").then(function(response) {
        self.skladlist = response.data;
      });
      axios.get("api/v1/kontragent/type/2").then(function(response) {
        const list = Array.isArray(response.data) ? response.data : [];
        self.kontragentlist = list.filter(k => Number(k.type) === 2);
      });
      axios.get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            const rate = Number(response.data && response.data.rate) || 1;
            self.datas.dollar_rate = rate;
            self.flex.dollar_rate = rate;
        });
  },
  methods: {
    // ════════ 🏷 PRIXOD BARCODE ════════
    async openBarcodeForPrixod(prixodId) {
      this.bcModal = {
        show: true, loading: true,
        prixodId, prixodNumber: '',
        priceType: 'chakana', showPrice: true,
        bulkCount: 1,
        list: [],
      };
      try {
        const res = await axios.get(`api/v1/prixod/id/${prixodId}`);
        const doc = res.data || {};
        this.bcModal.prixodNumber = doc.number || prixodId;
        const rows = doc.prixod_table || [];
        this.bcModal.list = rows.map(r => ({
          name: (r.product && (r.product.extra_name || r.product.name)) || '—',
          shtrix_kod: r.shtrix_kod || '',
          chakana_price: Number(r.chakana_price || 0),
          optom_price:   Number(r.optom_price   || 0),
          count: Math.max(1, Math.floor(Number(r.count || 1))),
          selected: !!(r.shtrix_kod),  // default: shtrix bor bo'lsa tanlangan
        }));
      } catch (e) {
        alert('Prixod yuklashda xato: ' + (e.response && e.response.data && e.response.data.message || e.message));
      } finally {
        this.bcModal.loading = false;
      }
    },

    toggleSelectAll(e) {
      const check = e.target.checked;
      this.bcModal.list.forEach(it => {
        if (it.shtrix_kod) it.selected = check;
      });
    },

    applyBulkCount() {
      const n = Math.max(0, Math.floor(Number(this.bcModal.bulkCount || 0)));
      // Tanlanganlar bo'lsa shularga, aks holda hammasiga
      const hasSelected = this.bcSelectedCount > 0;
      this.bcModal.list.forEach(it => {
        if (!it.shtrix_kod) return;
        if (hasSelected ? it.selected : true) {
          it.count = n;
        }
      });
    },

    printPrixodBarcodes() {
      const valid = this.bcModal.list.filter(it => it.selected && it.shtrix_kod && Number(it.count) > 0);
      if (!valid.length) {
        alert("Tanlangan va soni > 0 bo'lgan mahsulot yo'q");
        return;
      }
      this.$nextTick(() => {
        setTimeout(() => {
          const html = $('.bc-mybody').html();
          if (!html) { alert('Print markup tayyor emas'); return; }
          const w = window.open('', '_blank', 'width=420,height=700');
          w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Shtrix</title>
            <style>
              /* Sticker o'lchami: 58×40mm (Directory/Product/Index.vue bilan bir xil) */
              @page { size: 58mm 40mm; margin: 0; }
              * { box-sizing: border-box; }
              html, body { margin: 0; padding: 0; font-family: Arial, sans-serif; }
              .bc-page {
                width: 58mm; height: 40mm;
                page-break-after: always; page-break-inside: avoid;
                display: flex; flex-direction: column;
                align-items: center; justify-content: center;
                gap: 0.5mm; padding: 1mm 0; overflow: hidden;
              }
              .bc-page:last-child { page-break-after: auto; }
              .bc-name {
                font-size: 8pt; font-weight: 800;
                text-align: center; line-height: 1.1;
                max-height: 8mm; overflow: hidden;
                width: 100%; word-break: break-word;
                padding: 0 1mm;
              }
              .bc-price { font-size: 13pt; font-weight: 900; text-align: center; line-height: 1; }
              .bc-barcode-wrap {
                width: 100%;
                display: flex; justify-content: center; align-items: center;
                flex: 1;
                overflow: hidden;
              }
              .vue-barcode-element { width: 100% !important; display: block; }
              .vue-barcode-element svg {
                width: 100% !important;
                height: auto !important;
                max-height: 26mm;
                display: block;
                image-rendering: -webkit-optimize-contrast;
                image-rendering: crisp-edges;
                shape-rendering: crispEdges;
              }
              .vue-barcode-element text {
                font-size: 11pt !important;
                font-weight: 800 !important;
                letter-spacing: 1.2px;
              }
            </style>
            </head><body>${html}</body></html>`);
          w.document.close();
          // Print tugagandan keyin oynani avtomatik yopish
          w.onafterprint = () => { try { w.close(); } catch (_) {} };
          setTimeout(() => {
            w.focus();
            w.print();
            // Fallback: ba'zi brauzerlarda onafterprint ishlamaydi — 2 sek'da majburiy yopish
            setTimeout(() => { try { w.close(); } catch (_) {} }, 2000);
          }, 300);
        }, 100);
      });
    },

    handleFileUpload() {
        this.file = this.$refs.file.files;
        this.datas.file = URL.createObjectURL(this.$refs.file.files[0]);
      },
    onFlexFileChange(e) {
      this.flex.file = e.target.files[0] || null;
      this.flexResult = null;
    },
    async uploadFlex() {
      if (!this.flex.file) return;
      if (!this.flex.kontragent_id) { alert("Етказувчини танланг"); return; }
      if (!this.flex.sklad_id)      { alert("Складни танланг"); return; }
      this.flexLoading = true;
      this.flexResult = null;
      try {
        const fd = new FormData();
        fd.append("file_name", this.flex.file);
        fd.append("sklad_id", this.flex.sklad_id);
        fd.append("pay_type_id", this.flex.pay_type_id);
        fd.append("kontragent_id", this.flex.kontragent_id);
        fd.append("dollar_rate", this.flex.dollar_rate);
        fd.append("financial_enabled", this.flex.financial_enabled ? 1 : 0);
        const res = await axios.post("api/v1/upload/product-xlsx-flex", fd);
        this.flexResult = res.data;
        this.Data();
      } catch (e) {
        alert("Xato: " + (e.response?.data?.message || e.message));
      } finally {
        this.flexLoading = false;
      }
    },
    onRevFileChange(e) {
      this.revUpload.file = e.target.files[0] || null;
      this.revResult = null;
    },
    async uploadRevision() {
      if (!this.revUpload.file)     return;
      if (!this.revUpload.sklad_id) { alert("Складни танланг"); return; }
      this.revLoading = true;
      this.revResult = null;
      try {
        const fd = new FormData();
        fd.append("file_name", this.revUpload.file);
        fd.append("sklad_id",  this.revUpload.sklad_id);
        fd.append("comment",   this.revUpload.comment || '');
        const res = await axios.post("api/v1/upload/product-xlsx-revision", fd);
        this.revResult = res.data;
      } catch (e) {
        alert("Xato: " + (e.response?.data?.message || e.message));
      } finally {
        this.revLoading = false;
      }
    },
    Yuklash() {
        let self = this;
        if(self.send==false){
          self.send=true;
          let formData = new FormData();
        let file = self.file[0];
        formData.append("file_name", file);
        formData.append("sklad_id", this.datas.sklad_id);
        formData.append("pay_type_id", this.datas.pay_type_id);
        formData.append("dollar_rate", this.datas.dollar_rate);
        formData.append("kontragent_id", this.datas.kontragent_id);
        formData.append("user_id", localStorage.getItem("user_id"));
        formData.append("financial_enabled", this.datas.financial_enabled ? 1 : 0);
        axios({
          method: "post",
          url: "api/v1/upload/prixod",
          data: formData
        }).then(function (response) {
          self.datas.file="";
          self.file="";
          self.send=false;
          self.$bvModal.hide("modal-upload");
          self.Data();
        }).catch(function(error){
          self.send=false;
        });
        }else{
          console.log('not');
        }
      },
    filterFunction,
    Update(record, index) {
      if(this.rule.open==true){
      this.$router.push({ path: '/kirim/update/' + record.id});
      }
    },
    Shovedform() {
        this.$refs.file.focus();
      },
    Data() {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/prixod"
      }).then(function(response) {
        self.items = response.data;
        self.totalRows = self.items.length;
      });
    },
    Interval() {
      window.setInterval(() => {
        this.Data();
      }, 60000);
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Trash(id) {
      let self=this;
      self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            axios({
            method: "delete",
            url: "api/v1/prixod/id/" + id
          }).then(function(response) {
            self.Data();
          });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          }
        })
        .catch(function() {});
    }
  }
};
</script>

<style>
.z-top-modal { z-index: 9999 !important; }
.modal-backdrop.show { z-index: 9990 !important; }
</style>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* SEARCH */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

/* TUGMALAR */
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}

.add-btn sup {
  font-weight: 400;
  opacity: 0.7;
}

.tool-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  height: 40px;
  padding: 0 16px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: 0.2s;
}

.tool-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}

.refresh-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}

/* JADVAL KARTASI */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
  color: #334155;
}

.custom-table tbody tr:hover {
  background: #faf8ff;
  cursor: pointer;
}

/* ID BADGE */
.id-badge {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.font-bold {
  font-weight: 700;
}

.text-muted {
  color: #94a3b8;
}

/* AMALLAR */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

/* FOOTER */
.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
}

.empty-row {
  text-align: center;
  padding: 60px !important;
  color: #94a3b8;
  font-style: italic;
}

@media (max-width: 768px) {
  .g-page {
    padding: 10px;
  }

  .header-row {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .header-actions {
    flex-wrap: wrap;
  }

  .modern-search {
    width: 100%;
  }
}

/* ═════════════ 🏷 PRIXOD BARCODE MODAL ═════════════ */
.icon-btn.barcode {
  background: #fef3c7; color: #92400e;
}
.icon-btn.barcode:hover { background: #f59e0b; color: white; }

.bc-overlay {
  position: fixed; inset: 0;
  background: rgba(15,23,42,0.5);
  z-index: 9999;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(3px);
}
.bc-modal {
  background: white;
  border-radius: 20px;
  width: 900px; max-width: 96vw;
  max-height: 90vh;
  display: flex; flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
}
.bc-head {
  padding: 18px 22px;
  border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
}
.bc-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.bc-sub { font-size: 13px; color: #94a3b8; font-weight: 600; margin-left: 6px; }
.bc-close {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
}
.bc-body { padding: 16px 22px; overflow-y: auto; flex: 1; }
.bc-foot {
  padding: 14px 22px; border-top: 1px solid #f1f5f9;
  display: flex; gap: 10px; justify-content: flex-end;
}
.bc-options {
  display: flex; align-items: center; gap: 16px;
  margin-bottom: 14px; padding: 10px 14px;
  background: #f8fafc; border-radius: 10px;
}
.bc-opt { display: flex; flex-direction: column; gap: 4px; }
.bc-label { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; }
.bc-select {
  height: 36px; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.bc-toggle { display: flex; align-items: center; gap: 6px; cursor: pointer; user-select: none;
  font-size: 13px; font-weight: 600; color: #475569;
}
.bc-btn-clear {
  background: #fff1f2; color: #e11d48; border: 1.5px solid #fda4af;
  height: 36px; padding: 0 14px; border-radius: 8px;
  font-weight: 700; font-size: 12px; cursor: pointer;
}
.bc-btn-clear:hover { background: #e11d48; color: white; }

/* 🎯 Bulk-set */
.bc-bulk-row { display: flex; gap: 6px; align-items: center; }
.bc-btn-apply {
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none;
  height: 32px; padding: 0 12px;
  border-radius: 8px;
  font-weight: 800; font-size: 12px; cursor: pointer;
}
.bc-btn-apply:hover { opacity: 0.92; }

.bc-row-selected { background: #f5f3ff; }
.bc-no-code input[type="checkbox"] { cursor: not-allowed; }
.bc-empty {
  text-align: center; padding: 40px 20px;
  color: #94a3b8; font-weight: 600;
}
.bc-table { width: 100%; border-collapse: collapse; }
.bc-table th {
  background: #f8fafc; padding: 10px;
  font-size: 11px; font-weight: 800; color: #64748b;
  text-transform: uppercase; text-align: left;
  border-bottom: 1.5px solid #e8edf3;
}
.bc-table td {
  padding: 10px; border-bottom: 1px solid #f1f5f9;
  font-size: 13px; color: #1e293b;
}
.bc-pname { font-weight: 700; }
.bc-warn { font-size: 11px; color: #b91c1c; font-weight: 700; margin-top: 2px; }
.bc-mono { font-family: 'JetBrains Mono', monospace; font-weight: 700; color: #5850ec; }
.bc-qty {
  width: 80px; height: 32px;
  border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 14px; font-weight: 700;
  text-align: center; outline: none;
}
.bc-qty:focus { border-color: #5850ec; }
.bc-no-code { opacity: 0.6; background: #fef3f2; }
.bc-table tfoot td { background: #f1f5f9; padding: 12px 10px; }
.bc-btn-cancel {
  background: #f1f5f9; color: #64748b;
  border: none; height: 42px; padding: 0 20px;
  border-radius: 10px; font-weight: 700; cursor: pointer;
}
.bc-btn-print {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white; border: none;
  height: 42px; padding: 0 24px;
  border-radius: 10px; font-weight: 800; cursor: pointer;
  display: flex; align-items: center; gap: 8px;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.35);
}
.bc-btn-print:hover:not(:disabled) { opacity: 0.92; }
.bc-btn-print:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
